export const apiRoutes = {
  getTaxesByCode: '/service/payments/v1/deposit/verify',
  getTaxes: '/accounting/api/v1/taxes/calculate',
  getTaxesNew: '/accounting/api/v2/taxes/withdraw/calculate'
};
